import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { ThemeProvider as StyledThemeProvider } from 'styled-components'
import TagManager from 'react-gtm-module'

import theme from '../src/theme'

import GDPRSettingsPanel from './components/GDPRSettingsPannel'
import Gdpr from './relay/Gdpr/component'
import GlobalStyles from './theme/global'
import RoutesComponents from './router/RoutesComponents'
import MaintenancePage from './pages/Maintenance'
import { app } from './configuration'
import { selectors } from './redux'

type AppProps = {
  children?: React.ReactNode
}

const tagManagerArgs = {
  gtmId: app.GTM_ID,
}

TagManager.initialize(tagManagerArgs)

const App: FC<AppProps> = ({ children }) => {
  const maintenance = useSelector(selectors.app.maintenance)

  return (
    <HelmetProvider>
      <Helmet defaultTitle="Cymbae Declare"></Helmet>
      <StyledThemeProvider theme={theme}>
        <GlobalStyles />
        {children}
        <Gdpr />
        <GDPRSettingsPanel />
        {maintenance ? <MaintenancePage /> : <RoutesComponents />}
      </StyledThemeProvider>
    </HelmetProvider>
  )
}

export default App
